<script setup lang="ts">
const viewport = useViewport();

const breakpointLg = computed(() => viewport.isGreaterThan("lg"));
</script>

<template>
  <div class="mx-6 my-12 flex justify-center lg:my-6">
    <div v-if="breakpointLg" class="flex space-x-12">
      <div class="w-96 min-w-96">
        <slot name="left" />
      </div>
      <div class="w-full max-w-4xl">
        <slot name="right" />
      </div>
    </div>

    <div v-else>
      <div class="w-full py-2">
        <slot name="right" />
      </div>
      <div class="w-full py-2">
        <slot name="left" />
      </div>
    </div>
  </div>
</template>
